import { render, staticRenderFns } from "./ProfitSymbol.vue?vue&type=template&id=26762372&scoped=true&"
import script from "./ProfitSymbol.vue?vue&type=script&lang=ts&"
export * from "./ProfitSymbol.vue?vue&type=script&lang=ts&"
import style0 from "./ProfitSymbol.vue?vue&type=style&index=0&id=26762372&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26762372",
  null
  
)

export default component.exports